import { EField } from "./schema.indexContractBulkIndex.types";
export var getInitialValues = function (_a) {
    var _b;
    var letterTemplates = _a.letterTemplates, property = _a.property;
    return (_b = {},
        _b[EField.GenerateLetter] = true,
        _b[EField.LetterType] = letterTemplates === null || letterTemplates === void 0 ? void 0 : letterTemplates[0].id,
        _b);
};
